module.exports = __webpack_public_path__ + "static/media/screen-video-plantendokter.79655975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/video-screenshots/screen-video-plantendokter.jpg
// module id = 746
// module chunks = 0